import type { AxiosInstance } from 'axios';

export interface PurchaserAddress {
  id: string;
  fullName: string;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  countryCode: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export type CreatePurchaserAddressInput = Omit<PurchaserAddress, 'id' | 'createdAt' | 'updatedAt'>;
export type UpdatePurchaserAddressInput = Partial<CreatePurchaserAddressInput>;

export function createPurchaserAddressesService(client: AxiosInstance) {
  return {
    async list(): Promise<PurchaserAddress[]> {
      const { data } = await client.get<PurchaserAddress[]>('/purchasers/addresses');
      return data;
    },

    async create(input: CreatePurchaserAddressInput): Promise<PurchaserAddress> {
      const { data } = await client.post<PurchaserAddress>('/purchasers/addresses', input);
      return data;
    },

    async update(id: string, input: UpdatePurchaserAddressInput): Promise<PurchaserAddress> {
      const { data } = await client.patch<PurchaserAddress>(`/purchasers/addresses/${id}`, input);
      return data;
    },

    async remove(id: string): Promise<void> {
      await client.delete(`/purchasers/addresses/${id}`);
    },
  };
}

export type PurchaserAddressesService = ReturnType<typeof createPurchaserAddressesService>;
